import React, { forwardRef, useCallback, useEffect, useImperativeHandle, useState } from 'react'
import { TabPanel } from 'devextreme-react/tab-panel'
import { setFormDataFieldErrorTabActive } from '../helpers.jsx'

const Index = forwardRef(({
  errors,
  stylingMode = 'secondary',
  deferRendering = false,
  children,
  className,
  animationEnabled = false,
  panelProps
}, ref) => {
  const [selectedTab, setSelectedTab] = useState(0)
  const [tabsInputs, setTabsInputs] = useState([])

  useEffect(() => {
    errors && setFormDataFieldErrorTabActive(errors, tabsInputs, setSelectedTab)
  }, [errors])

  useImperativeHandle(ref, () => {
    return {
      setSelectedTab
    }
  }, [])

  const onTabSelectionChanged = useCallback((e) => {
    const matchNumber = e.addedItems[0].template.match(/(?<=\[).+?(?=])/g)

    setSelectedTab(matchNumber.length ? parseInt(matchNumber[0]) : -1)
  }, [])

  const onTabItemRendered = useCallback((e) => {
    const inputs = e.itemElement.getElementsByTagName('input')

    if (e.itemIndex === 0) {
      setTabsInputs([inputs])
    } else {
      setTabsInputs(old => [...old, inputs])
    }
  }, [])

  const renderChildren = () => {
    const childrenMap = Array.isArray(children) ? children : [children]

    return React.Children.map(childrenMap.filter(c => c), (child, index) => {
      const newProps = {}

      if (child?.props?.children) {
        const childrenMap2 = Array.isArray(child.props.children) ? child.props.children : [child.props.children]

        newProps.children = React.Children.map(childrenMap2, (child2) => {
          return React.cloneElement(child2, {
            tabActive: index === selectedTab,
            setSelectedTab
          })
        })
      }

      return child
        ? React.cloneElement(child, newProps)
        : child
    })
  }

  return (
    <TabPanel
      animationEnabled={animationEnabled}
      stylingMode={stylingMode}
      deferRendering={deferRendering}
      selectedIndex={selectedTab}
      swipeEnabled={false}
      showNavButtons
      scrollByContent
      onSelectionChanged={onTabSelectionChanged}
      onItemRendered={onTabItemRendered}
      className={className}
      {...panelProps}
    >
      {renderChildren()}
    </TabPanel>
  )
})

export default Index
